import React from "react";
import MyContainer from "@/components/MyContainer";
import MessageTemplateAsyncTable from "@/pages/message-template/components/template-async-table";
import { LinkButton } from "@/components/ui/buttons/link-button";
import { useLocation } from "wouter";

export default function MessageTemplatePage() {
  const [, setLocation] = useLocation();

  const handleCreate = () => {
    setLocation("/message-templates/create");
  };

  return (
    <MyContainer
      enableBack={false}
      title="Message Templates"
      actions={<LinkButton label="Template" onClick={handleCreate} />}
    >
      <MessageTemplateAsyncTable />
    </MyContainer>
  );
}
